import { connect } from 'react-redux';
import { deleteUser, startUpdateUser, updateUser } from '../../../actions/authorization';
import { getAuthorizationUsers, getMyPermissions } from '../../../reducers/analyticsApp';
import UsersTablePane from '../../../components/authorization/users/UsersTablePane';
import { staticPermissions } from '../../../constants/authorization';

const mapStateToProps = (state) => ({
  users: getAuthorizationUsers(state),
  hasPermission: getMyPermissions(state).has(staticPermissions.AUTHORIZATION_MANAGE),
});

export default connect(mapStateToProps, {
  onAdd: startUpdateUser,
  onUpdate: startUpdateUser,
  onDelete: deleteUser,
  onRestore: updateUser,
})(UsersTablePane);
